//Patient portal
const PatientRoutes = {
    path: "/patient",
    component: () =>
        import(
            /* webpackChunkName: "PatientBase.vue" */
            "@/modules/patient/views/PatientBase.vue"
        ),
    meta: {
        theme: "patient",
        patientOnly: true,
    },
    children: [
        {
            path: "/",
            component: () =>
                import(
                    /* webpackChunkName: "PatientAccount" */
                    "@/modules/patient/views/AccountView.vue"
                ),
        },
        {
            path: "contracts",
            component: () =>
                import(
                    /* webpackChunkName: "PatientContracts" */
                    "@/modules/patient/views/ContractsView.vue"
                ),
        },
        {
            path: "insurance",
            component: () =>
                import(
                    /* webpackChunkName: "PatientInsurance" */
                    "@/modules/patient/views/InsuranceView.vue"
                ),
        },
        {
            path: "profile",
            component: () =>
                import(
                    /* webpackChunkName: "PatientProfileView.vue" */
                    "@/modules/patient/views/ProfileView.vue"
                ),
        },
        {
            path: "profile/edit",
            component: () =>
                import(
                    /* webpackChunkName: "PatientProfileEditView.vue" */
                    "@/modules/patient/views/ProfileEditView.vue"
                ),
            children: [
                {
                    path: "identity",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileIdentity" */
                            "@/modules/profile/views/IdentityView.vue"
                        ),
                    meta: {
                        profilePage: "Identity",
                    },
                },
                {
                    path: "reason",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileReason" */
                            "@/modules/profile/views/ReasonView.vue"
                        ),
                    meta: {
                        profilePage: "Reason",
                    },
                },
                {
                    path: "Family",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileFamily" */
                            "@/modules/profile/views/FamilyView.vue"
                        ),
                    meta: {
                        profilePage: "Family",
                    },
                },
                {
                    path: "contacts",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileContacts" */
                            "@/modules/profile/views/ContactsView.vue"
                        ),
                    meta: {
                        profilePage: "Contacts",
                    },
                },
                {
                    path: "medical",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileMedical" */
                            "@/modules/profile/views/MedicalView.vue"
                        ),
                    meta: {
                        profilePage: "Medical",
                    },
                },
                {
                    path: "substance",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileSubstance" */
                            "@/modules/profile/views/SubstanceView.vue"
                        ),
                    meta: {
                        profilePage: "Substance",
                    },
                },
                {
                    path: "social",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileSocial" */
                            "@/modules/profile/views/SocialView.vue"
                        ),
                    meta: {
                        profilePage: "Social",
                    },
                },
                {
                    path: "education",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileEducation" */
                            "@/modules/profile/views/EducationView.vue"
                        ),
                    meta: {
                        profilePage: "Education",
                    },
                },
                {
                    path: "employment",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileEmployment" */
                            "@/modules/profile/views/EmploymentView.vue"
                        ),
                    meta: {
                        profilePage: "Employment",
                    },
                },
                {
                    path: "culture",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProfileCulture" */
                            "@/modules/profile/views/CultureView.vue"
                        ),
                    meta: {
                        profilePage: "Culture",
                    },
                },
            ],
        },
        {
            path: "assessment",
            component: () =>
                import(
                    /* webpackChunkName: "PatientAssessment" */
                    "@/modules/assessments/views/AssessmentView.vue"
                ),
            meta: {
                patientOnly: false,
            },
        },
        {
            path: "progress",
            component: () =>
                import(
                    /* webpackChunkName: "PatientProgress" */
                    "@/modules/patient/views/ProgressView.vue"
                ),
        },
        {
            path: "treatment",
            component: () =>
                import(
                    /* webpackChunkName: "PatientTreatment" */
                    "@/modules/patient/views/TreatmentView.vue"
                ),
        },
        {
            path: "outcome",
            component: () =>
                import(
                    /* webpackChunkName: "PatientOutcome" */
                    "@/modules/patient/views/OutcomeView.vue"
                ),
        },
        {
            path: "documents",
            component: () =>
                import(
                    /* webpackChunkName: "PatientDocuments" */
                    "@/modules/patient/views/DocumentsView.vue"
                ),
        },
        {
            path: "message",
            component: () =>
                import(
                    /* webpackChunkName: "PatientMessage" */
                    "@/modules/patient/views/PatientMessageView.vue"
                ),
        },
        {
            path: "appointment",
            component: () =>
                import(
                    /* webpackChunkName: "PatientAppointment" */
                    "@/modules/patient/views/PatientAppointmentView.vue"
                ),
        },
        {
            path: "assessments",
            component: () =>
                import(
                    /* webpackChunkName: "PatientAssessments" */
                    "@/modules/patient/views/AssessmentsView.vue"
                ),
        },
        {
            path: "consents",
            component: () =>
                import(
                    "@/modules/patient/views/ConsentsView.vue"
                ),
        },
        {
            path: "scheduler",
            component: () =>
                import(
                    /* webpackChunkName: "PatientOutcome" */
                    "@/modules/patient/views/SchedulerView.vue"
                ),
        },
        {
            path: "consentforms",
            component: () =>
                import(
                    "@/modules/patient/views/ConsentFormsView.vue"
                ),
        },
        {
            path: "consentform/:consentform_id",
            component: () =>
                import(
                    "@/modules/patient/views/ConsentFormView.vue"
                ),

        },

        {
            path: "consentsignedform/:consentsignedform_id",
            component: () =>
                import(
                    "@/modules/patient/views/ConsentSignedForm.vue"
                ),

        },
        {
            path: "dailyTracking",
            component: () =>
                import(
                    "@/modules/patient/views/DailyTrackingView.vue"
                ),
        },
        {
            path: "journal",
            component: () =>
                import(
                    "@/modules/patient/views/JournalView.vue"
                ),
        },
        {
            path: "medCheck",
            component: () =>
                import(
                    "@/modules/patient/views/MedCheckView.vue"
                ),
        },
        {
            path: "dream",
            component: () =>
                import(
                    "@/modules/patient/views/DreamView.vue"
                ),
        },
        {
            path: "journals",
            component: () =>
                import(
                    "@/modules/patient/views/JournalHistorysView.vue"
                ),
        },
        {
            path: "dailyTrackings",
            component: () =>
                import(
                    "@/modules/patient/views/DailyTrackingHistorysView.vue"
                ),
        },
        {
            path: "dreams",
            component: () =>
                import(
                    "@/modules/patient/views/DreamHistorysView.vue"
                ),
        },
    ],
};
export default PatientRoutes;
